<script>
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
</script>

<Section backgroundColor="white">
	<h2>Data Driven Results</h2>
	<Grid columns={3} rows={3} center>
		<Grid subgrid vertical class="card">
			<h3 class="card__header">Museum Grade Inserts</h3>
			<div class="conic-gradient conic-gradient--98">
				<p class="conic-gradient__stat">
					<span>Block UV Rays</span>
					<span>98%</span>
				</p>
			</div>
			<p class="card__footer card__footer--98">
				Museum grade inserts provide excellent UV protection by
				<span>blocking 99% of all ultraviolet</span> radiation coming through your
				windows.
			</p>
		</Grid>

		<Grid subgrid vertical class="card">
			<h3 class="card__header">Sleep Panels</h3>
			<div class="conic-gradient conic-gradient--100">
				<p class="conic-gradient__stat">
					<span>100%</span>
					<span>Blackout</span>
				</p>
			</div>
			<p class="card__footer card__footer--100">
				Sleep panels <span>offer 100% blackout</span> and superior draft reduction
				while cutting noise and meeting historic preservation codes.
			</p>
		</Grid>

		<Grid subgrid vertical class="card">
			<h3 class="card__header">Privacy Grade</h3>
			<div class="conic-gradient conic-gradient--60">
				<p class="conic-gradient__stat">
					<span>60%</span>
					<span>Light Transmission Rating</span>
				</p>
			</div>
			<p class="card__footer card__footer--60">
				privacy grade offers a balance of light diffusion and transmittance with
				<span>60% light transmission rating</span> and high uv absorption.
			</p>
		</Grid>
	</Grid>
</Section>

<style>
	:root {
		--text-small: 1rem;
		--text-large: 2.2rem;
		--line-height-small: 0.9em;
		--line-height-normal: 1em;
	}

	.card__footer {
		text-transform: uppercase;
		font-size: 0.8rem;
		font-weight: bold;
		line-height: var(--line-height-normal);
	}

	.card__footer--98 span {
		color: var(--color-indow-blue);
	}

	.card__footer--100 span {
		color: black;
	}

	.card__footer--60 span {
		color: var(--color-indow-yellow);
	}

	.card__header {
		text-transform: uppercase;
		font-size: 1.4rem;
	}

	.conic-gradient {
		aspect-ratio: 1 / 1;
		width: 60%;
		border-radius: 100%;
		background-color: var(--color-indow-grey);
		display: flex;
		justify-content: center;
		align-items: center;
		overflow: hidden;
	}

	.conic-gradient--60 {
		background: conic-gradient(
			var(--color-indow-yellow) 60%,
			var(--color-indow-grey) 60%,
			var(--color-indow-grey) 100%
		);
	}

	.conic-gradient--98 {
		background: conic-gradient(
			var(--color-indow-blue) 98%,
			var(--color-indow-grey) 98%,
			var(--color-indow-grey) 100%
		);
	}

	.conic-gradient--98 .conic-gradient__stat span:last-of-type {
		font-size: var(--text-large);
	}

	.conic-gradient--98 .conic-gradient__stat span:first-of-type {
		font-size: var(--text-small);
	}

	.conic-gradient__stat {
		display: flex;
		flex-direction: column;
		gap: 0em;
		color: var(--pure-white);
		font-size: var(--text-small);
		text-transform: uppercase;
	}

	.conic-gradient__stat span:last-of-type {
		line-height: var(--line-height-small);
	}

	.conic-gradient__stat span:first-of-type {
		font-size: var(--text-large);
		line-height: var(--line-height-normal);
	}
</style>
